import axios from "axios"



const axiosInstance = axios.create({
    baseURL: `https://${process.env.REACT_APP_IP}/api/`,
    headers: {
        "Content-Type": "application/json"
    }
});

export const apiService = async (method, endpoint, data, onSuccess, onerror) => {
    try {
        const response = await axiosInstance({ method, url: endpoint, data });
        onSuccess?.(response.data);

        return response.data;
    } catch (error) {
        const errorMessage = error || "An error occurred";
        onerror?.(errorMessage);

       
    }
}



// Interceptors
axiosInstance.interceptors.request.use(
    (config) => {

        const user = localStorage.getItem("user");
        if (user) {
            var parsed = JSON.parse(user);
            config.headers.Authorization = `Bearer ${parsed.token}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

// Log out the user if we get a 401. 
axiosInstance.interceptors.response.use(
    (response) => { return response },
    async (error) => {
        // Check if error response is present and error status is 401 (Unauthorized)
        if (error.response && error.response.status === 401) {
            // Handle unauthorized error (e.g., redirect to login page)
            console.log("Unauthorized! Logging out...");
            localStorage.removeItem("user");
            window.location.href = "/login"; // Redirect to login page
        }
        return Promise.reject(error);
    }
);

